<template>
    <section :aria-label="$t('language-choice')">
        <p class="mb-0 text-center text-sm-end text-xl-center">
            <router-link :to="{ name: '' }"
                v-for="language in availableLanguages"
                :key="language.locale"
                @click.native="changeLanguage(language.locale)"
                :aria-label="$t('language-choice')"
                class="language-choice"
                v-bind:class="$screen.width > 576 ? 'language-name' : 'language-locale'"
            >
                <span v-if="$screen.width > 576"> {{ language.name }} </span>
                <img
                    :src="require(`@/assets/images/${language.locale.toUpperCase()}.png`)"
                    :height="imgHeight"
                    :aria-label="$t('language-choice')"
                    v-else
                >
            </router-link>
        </p>
    </section>
</template>
<script>
import { EventBus } from '@/helpers/EventBus.js';
import { Default }  from '@/helpers/Default.js';
import _            from 'underscore';

export default {
    data () {
        return {
            imgHeight:       25,
            timer:           20,
            fontSizeSetting: Default.size,
            languages: [
                {
                    locale: 'fr',
                    name:   'Français'
                },
                {
                    locale: 'en',
                    name:   'English'
                }
            ]
        };
    },
    mounted () {
        if (this.$session.has('growFont')) {
            this.fontSizeSetting = this.$session.get('growFont');
        }

        // Update the setting window too when the font size changes
        EventBus.$on('grow-font', this.changeFontSize);

        this.resizeImage();

        this.$nextTick(() => {
            window.addEventListener('resize', this.resizeImage);
        })
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.resizeImage);
    },
    computed: {
        /**
         * Available Languages
         * Removed the currently selected language
         *
         * @return     {array}
         */
        availableLanguages () {
            return _.filter(this.languages, (language) => language.locale !== this.$i18n.locale);
        }
    },
    methods: {
        /**
         * Update the setting page when font size changes
         */
        changeFontSize () {
            this.fontSizeSetting = this.$session.get('growFont');
            this.resizeImage();
        },

        /**
         * Change language
         *
         * @param    {string}    locale    The new locale
         *
         * @return    void
         */
        changeLanguage (locale) {
            if (this.$i18n.locale === locale) {
                return;
            }

            const getHTMLTag = document.documentElement;
            getHTMLTag.setAttribute("lang", locale);

            // Set the locale into local storage
            window.localStorage.setItem('locale', locale);

            // Change the i18n locale
            const oldLocale   = this.$i18n.locale;
            this.$i18n.locale = locale;

            if (!this.$route.name.includes('home')) {
                // Change URL
                this.$router.push({ name: this.$route.name.replace(oldLocale, locale) });
            }
            EventBus.$emit('locale-changed');
        },

        /**
         * Resize the font image to be like the font-size.
         */
        resizeImage () {
            // Wait this timer to get font-size.
            setTimeout(() => {
                this.imgHeight = 25;

                if (this.fontSizeSetting === 'big-font') {
                    this.imgHeight += 3;
                } else if (this.fontSizeSetting === 'giant-font') {
                    this.imgHeight += 6;
                }
            }, this.timer);
        }
    }
};
</script>
